





































































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import {
  AppData,
  INCOME_RANGE,
} from "@/models/app-data";
import CommonMixin, { County } from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { IncomeRangeContent } from "@/models/content/income-range";
import { WorkflowService } from "@/service/workflow.service";
import { SettingsService } from "@/service/settings.service";
import { FplSettings } from "@/models/fpl-settings";
import PageLoader from "@/components/PageLoader.vue"
import { QualifierRule, matchQualifiers } from "@/models/rules";

@Component({
  components: {
    FooterButton,
    PageLoader
  }
})
export default class IncomeRange extends Mixins(CommonMixin) {
  workflowService = new WorkflowService();
  one = INCOME_RANGE.FPL_LVL_1_OR_LESS;
  two = INCOME_RANGE.FPL_LVL_1_TO_LVL_2;
  three = INCOME_RANGE.FPL_LVL_2_TO_LVL_3;
  four = INCOME_RANGE.FPL_LVL_3_PLUS;
  Selection = INCOME_RANGE.FPL_NONE;
  PercentDone = 75;
  appData = {} as AppData;
  content: IncomeRangeContent = {} as IncomeRangeContent;
  textDirection = 'ltr'
  fplSettings: FplSettings = {} as FplSettings;

  async mounted(): Promise<void> {
    try {
      const settingsService = new SettingsService();
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getIncomeRangeContent();
      this.textDirection = contentService.TextDirection();
      this.fplSettings =  await settingsService.getFPLSettings();

      // Import the workflow if one is provided
      await this.loadData();
      if (this.appData != null) {
        if (this.appData.fpl != null) {
          this.Selection = this.appData.fpl;
        }
        await this.putWorkflowStep( this.appData.workflowId, "IncomeRange") 
      }

    } catch (error) {
      this.showError(error as any);
    }
  }

  get showPageLoader(): boolean {
    return this.FplLevel1 == ""
  }

  get FplLevel1(): string {
    let amount = "";

    if (this.appData != null && this.appData.eligibleIncome != null) {
      const multiplier = this.fplSettings.FPL_LEVEL_1_MAX / 100;
      const income = Math.floor(this.appData.eligibleIncome * multiplier);
      amount = "$" + income.toLocaleString();
    }
    return amount;
  }

  get FplLevel2(): string {
    let amount = "";

    if (this.appData != null && this.appData.eligibleIncome != null) {
      const multiplier = this.fplSettings.FPL_LEVEL_2_MAX / 100;
      const income = Math.floor(this.appData.eligibleIncome * multiplier);
      amount = "$" + income.toLocaleString();
    }
    return amount;
  }

  get FplLevel3(): string {
    let amount = "";

    if (this.appData != null && this.appData.eligibleIncome != null) {
      const multiplier = this.fplSettings.FPL_LEVEL_3_MAX / 100;
      const income = Math.floor(this.appData.eligibleIncome * multiplier);
      amount = "$" + income.toLocaleString();
    }
    return amount;
  }

  disableNext(): boolean {
    return this.Selection === INCOME_RANGE.FPL_NONE;
  }

  public handleNextPageEvent(): void {
    if (this.appData == null) {
      this.appData = {} as AppData;
    }
    this.appData.fpl = this.Selection;
    this.saveAppData(this.appData);

    if (this.allChildrenUnder4(this.appData)) {
      this.handleAllUnderFour();
    } else if (this.allChildren4AndOver(this.appData)) {
      this.handleAllFourAndOver();
    } else if (this.childrenBothOverAndUnder4(this.appData)) {
      this.handleBothUnderAndOverFour();
    }
  }

 handleAllUnderFour(): void {

   const rules: QualifierRule[] = [
     { index: [undefined, County.Wayne, INCOME_RANGE.FPL_LVL_1_OR_LESS], path: 'MatchHeadstartReferral' }
    ,{ index: [undefined, County.Oakland, INCOME_RANGE.FPL_LVL_1_OR_LESS], path: 'MatchHeadstartReferral' }
    ,{ index: [undefined, County.Macomb, INCOME_RANGE.FPL_LVL_1_OR_LESS], path: 'MatchHeadstartReferral' }
    ,{ index: [undefined, County.Washtenaw, INCOME_RANGE.FPL_LVL_1_OR_LESS], path: 'MatchHeadstartReferral'}
    ,{ index: [undefined, undefined, INCOME_RANGE.FPL_LVL_1_TO_LVL_2], path: 'AlternateHSQualifier' }
    ,{ index: [undefined, undefined, INCOME_RANGE.FPL_LVL_2_TO_LVL_3], path: 'AlternateHSQualifier' }
    ,{ index: [undefined, undefined, INCOME_RANGE.FPL_LVL_3_PLUS], path: 'AlternateHSQualifier' }
   ]
   const rule = matchQualifiers(rules, false,  this.appData.county, this.appData.fpl)
    if (rule == null) {
        this.$router.push({ path: 'MatchNone' });
        return;
    }
    this.$router.push({ path: rule.path });
  }

  handleAllFourAndOver(): void {

   const rules: QualifierRule[] = [
    { index: [undefined, undefined, INCOME_RANGE.FPL_LVL_1_OR_LESS], path: 'PreviouslyAppliedHS' }
    ,{ index: [undefined, undefined, INCOME_RANGE.FPL_LVL_1_TO_LVL_2], path: 'MatchGSRPReferral' }
    ,{ index: [undefined, undefined, INCOME_RANGE.FPL_LVL_2_TO_LVL_3], path: 'MatchGSRPReferral' }
    ,{ index: [undefined, undefined, INCOME_RANGE.FPL_LVL_3_PLUS], path: 'MatchGSRPReferral' }
   ]

   const rule = matchQualifiers(rules, false,  this.appData.county, this.appData.fpl)
    if (rule == null) {
        this.$router.push({ path: 'MatchNone' });
        return;
    }
    this.$router.push({ path: rule.path });
  }

  handleBothUnderAndOverFour(): void {
    switch (this.Selection) {
      case INCOME_RANGE.FPL_LVL_1_OR_LESS:
        this.$router.push({ path: "PreviouslyAppliedHS" });
        break;
      case INCOME_RANGE.FPL_LVL_1_TO_LVL_2:
      case INCOME_RANGE.FPL_LVL_2_TO_LVL_3:
      case INCOME_RANGE.FPL_LVL_3_PLUS:
        this.$router.push({ path: "AlternateHSQualifierUnder4" });
        break;
    }
  }

  async loadData(): Promise<void> {
    if (this.$route?.query?.workflowid != null) {
      const workflowId = this.$route.query.workflowid + "";
      const appData = await this.workflowToAppData(workflowId);
      this.saveAppData(appData);
      this.appData = appData;
      //If we don't have any eligibleIncome, go to InitialRequirements
      if (appData.eligibleIncome == null || appData.eligibleIncome === 0) {
        this.$router.replace({ path: "InitialRequirements" });
      }
    } else {
      this.appData= this.getAppData();
    }
  }
}
